import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import buttonFilter from '@/components/button/filter'
import clientIp from '@/components/services/url-shortener-tracking/commons/clientIp'

function renderDomain(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.domain,
        label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.domain`),
        service: Services['url-shortener-settings/domains'],
        itemValue: 'name',
        itemTitle: 'name',
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.domain = event
        }
      }
    }
  )
}
function renderClientIp(h) {
  return h(
    clientIp,
    {
      props: {
        value: this.proxy.clientIp
      },
      on: {
        input: event => {
          this.proxy.clientIp = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [ renderClientIp.call(this, h) ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener-tracking']}-filter`
    },
    [
      renderDomain.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
